import React from 'react'
import {
  CrossSellPricingTableHeader,
  CrossSellPricingTableHeaderPlan,
  CrossSellPricingTableHeaderPlans,
  CrossSellPricingTableHeaderSeparator,
  CrossSellPricingTableStyled,
  CrossSellPricingTableHeaderTitle,
} from 'Features/CrossSell/CrosSellPricing/CrossSellPricing.styled'
import { PlanFeaturesTable } from 'Features/pricing/components/PlanFeaturesTable/PlanFeaturesTable'
import { PaidMarketingTableData } from 'Features/pricing/tabs/PaidMarketing/PaidMarketingTableData'
import { BotMitigationTableData } from 'Features/pricing/tabs/BotMitigation/BotMitigationTableData'
import { PRODUCT_TYPES, ProductTypes } from 'Types/ProductTypes'
import { useTranslation } from 'react-i18next'

type CrossSellFeaturesTableProps = {
  productType: ProductTypes
}

export const CrossSellFeaturesTable = ({ productType }: CrossSellFeaturesTableProps) => {
  const { t } = useTranslation('pricing')
  return (
    <CrossSellPricingTableStyled>
      <CrossSellPricingTableHeader>
        <CrossSellPricingTableHeaderTitle>
          {t('cross-sell.cross_sale_pricing.features')}
        </CrossSellPricingTableHeaderTitle>
        <CrossSellPricingTableHeaderPlans>
          <CrossSellPricingTableHeaderSeparator />
          <CrossSellPricingTableHeaderPlan>
            {t('cross-sell.cross_sale_pricing.core')}
          </CrossSellPricingTableHeaderPlan>
          <CrossSellPricingTableHeaderSeparator />
          <CrossSellPricingTableHeaderPlan>
            {t('cross-sell.cross_sale_pricing.advanced')}
          </CrossSellPricingTableHeaderPlan>
          <CrossSellPricingTableHeaderSeparator />
          <CrossSellPricingTableHeaderPlan>
            {t('cross-sell.cross_sale_pricing.enterprise')}
          </CrossSellPricingTableHeaderPlan>
        </CrossSellPricingTableHeaderPlans>
      </CrossSellPricingTableHeader>
      <PlanFeaturesTable
        data={
          productType === PRODUCT_TYPES.PAID_MARKETING
            ? PaidMarketingTableData
            : BotMitigationTableData
        }
      />
    </CrossSellPricingTableStyled>
  )
}
